import { render, staticRenderFns } from "./addCommodity.vue?vue&type=template&id=3929f221&scoped=true&"
import script from "./addCommodity.vue?vue&type=script&lang=ts&"
export * from "./addCommodity.vue?vue&type=script&lang=ts&"
import style0 from "./addCommodity.vue?vue&type=style&index=0&id=3929f221&lang=scss&scoped=true&"
import style1 from "./addCommodity.vue?vue&type=style&index=1&id=3929f221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3929f221",
  null
  
)

export default component.exports